// GENERATED FILE - DO NOT MODIFY

export enum MessageReadStatusDto {
    Unread = "Unread",
    Read = "Read",
    Deleted = "Deleted",
}